import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@mantine/core';
import { IconHome } from '@tabler/icons-react';
import { ADMIN_HOME_PATH } from '@/lib/navigation';

export default function NotFoundPage() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] p-8 text-center">
            <h1 className="text-6xl font-black text-gray-200 mb-4">404</h1>
            <p className="text-gray-500 max-w-md mb-8">
                {t('page_not_found')}
            </p>
            <Button
                component={Link}
                to={ADMIN_HOME_PATH}
                size="md"
                color="black"
                radius="md"
                leftSection={<IconHome size={18} />}
            >
                {t('home')}
            </Button>
        </div>
    );
}
